import { IAlert } from '@store/types';
import { EventEmitter } from 'eventemitter3';

export const emitter = new EventEmitter();

export enum EmitterEvent {
  Alert = 'Alert',
  BasketProductChanged = 'BasketProductChanged',
  BasketReload = 'BasketReload',
}

export const emit = {
  alert: (alert: IAlert) => emitter.emit(EmitterEvent.Alert, alert),
  basket: {
    productChanged: (data: any) => emitter.emit(EmitterEvent.BasketProductChanged, data),
    reload: (widgetUrl: string) => emitter.emit(EmitterEvent.BasketReload, widgetUrl),
  },
};
